export { default as NodeEnv } from './application-environments';

export const chromeComponents = {
  HEADER: 'header',
  FOOTER: 'footer',
  PIVOT_NAV: 'pivotNav',
  NAV: 'nav',
} as const;

export type ChromeComponent =
  (typeof chromeComponents)[keyof typeof chromeComponents];

export const STORM_UI_THEME_MODE_STORAGE_KEY = 'STORM_UI_THEME_MODE';
export const STORM_UI_THEME_MODE_BROADCAST_CHANNEL_KEY =
  'STORM_UI_THEME_MODE_CHANNEL';
